import React, { FunctionComponent } from 'react';

import { SourceDropDown } from '../../types/models';
import PopupDialog from '../shared/PopupDialog';

interface Props {
  isOpen: boolean;
  source: Partial<SourceDropDown> | undefined;
  onClose: () => void;
}

const InvalidSelectionDialog: FunctionComponent<Props> = ({
  isOpen,
  source,
  onClose,
}) => {
  let requirements;

  if (source === 'inputs') {
    requirements = 'at least one scenario and input';
  } else if (source === 'outputs') {
    requirements = 'at least one scenario, output, and timescale';
  } else {
    requirements = 'either an input or output source';
  }

  return (
    <PopupDialog
      open={isOpen}
      close={onClose}
      title="Invalid Selection"
      hideCloseButton
      primaryButtons={[
        {
          id: 'invalid-selection-dialog-ok',
          label: 'Ok',
          onClick: onClose,
        },
      ]}
    >
      You must select {requirements} to generate a report.
    </PopupDialog>
  );
};

export default InvalidSelectionDialog;
